export const getEventModelName = (eventData: { eventType: string | null; relation: string | null }) => {
    if (!eventData) return null;
    const { eventType, relation } = eventData;
    return `${relation ?? ""}${eventType ?? ""}`;
};
